// Legacy code, just modularized

import $ from 'jquery';

const navigation = {

  init: function() {
    $('.toggle-menu').on('click', function() {
      $(this).toggleClass('open');
      $('.mobile-nav-wrap').slideToggle();
    });

    $('.toggle-menu-item').on('click', function() {
      $(this).toggleClass('open');
      $(this).prev('.navigation.level-1').slideToggle();
    });
  }
};

export default navigation;
